Object.defineProperty(exports, "__esModule", {
    value: true
});

var _isomorphicFetch = require('isomorphic-fetch');

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        currencies: _constants.CRYPTOCOMPARE_CURRENCIES
    },
        _ref$currencies = _ref.currencies,
        currencies = _ref$currencies === undefined ? _constants.CRYPTOCOMPARE_CURRENCIES : _ref$currencies,
        _ref$extraParams = _ref.extraParams,
        extraParams = _ref$extraParams === undefined ? '' : _ref$extraParams;

    var url = 'https://min-api.cryptocompare.com/data/price?fsym=ETH&tsyms=' + currencies.join(',');
    if (extraParams) {
        url += '&extraParams=' + extraParams;
    }

    return (0, _isomorphicFetch2['default'])(url).then(function (response) {
        if (response.ok) {
            return response.json().then(function (json) {
                return { json: json, response: response };
            });
        }

        throw new Error('Can not connect to https://mini-api.cryptocompare.com to get price data, please check your internet connection.', response.status);
    });
};

module.exports = exports['default'];
//# sourceMappingURL=fetchPrices.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ethtools/build/fetchPrices.js
// module id = RJIW
// module chunks = 0